/**
 * avatars/aliens/species-ids.js
 * Định danh 30 chủng tộc người bản địa văn minh liên hành tinh.
 */

export const SPECIES_IGNIS = 'species_ignis';
export const SPECIES_CYCLOPIA = 'species_cyclopia';
export const SPECIES_BIONIC = 'species_bionic';
export const SPECIES_CRYO = 'species_cryo';
export const SPECIES_OCEAN = 'species_ocean';
export const SPECIES_MYCELIUM = 'species_mycelium';
export const SPECIES_SYNAPSE = 'species_synapse';
export const SPECIES_AURORA = 'species_aurora';
export const SPECIES_OSSIFIED = 'species_ossified';
export const SPECIES_QUANTUM = 'species_quantum';
export const SPECIES_DRAKONIS = 'species_drakonis';

// Đợt 1 (Batch 1): Sinh Thái Tự Nhiên & Côn Trùng
export const SPECIES_SYLVA = 'species_sylva';
export const SPECIES_INSECT = 'species_insect';
export const SPECIES_VENOM = 'species_venom';
export const SPECIES_DUNE = 'species_dune';

// Đợt 2 (Batch 2): Ánh Sáng & Đất Đá Kim Loại
export const SPECIES_SERAPH = 'species_seraph';
export const SPECIES_LITHOS = 'species_lithos';
export const SPECIES_GEM = 'species_gem';
export const SPECIES_MERCURY = 'species_mercury';

// Đợt 3 (Batch 3): Hoàng Kim, Cơ Khí & Điện Từ
export const SPECIES_MIDAS = 'species_midas';
export const SPECIES_STEAMPUNK = 'species_steampunk';
export const SPECIES_FULGOR = 'species_fulgor';
export const SPECIES_ASTRAL = 'species_astral';

// Đợt 4 (Batch 4): Nguyên Tố & Trọng Lực
export const SPECIES_ZEPHYR = 'species_zephyr';
export const SPECIES_RADIATION = 'species_radiation';
export const SPECIES_GRAVITON = 'species_graviton';
export const SPECIES_CHRONO = 'species_chrono';

// Đợt 5 (Batch 5): Vũ Trụ Sâu & Hư Không
export const SPECIES_NEBULA = 'species_nebula';
export const SPECIES_VOID = 'species_void';
export const SPECIES_SINGULARITY = 'species_singularity';
